module.exports = "/_next/static/images/OrchestrateTheOutcomes@2x-a570ee360e1e8698afea6bcae18ea59e.webp";